enum DeviationEnum {
	'scheduled_leave',
	'scheduled_leave_by_sick_or_paidleave',
	'underworked_hours',
	'overworked_hours',
	'full_time_limit_exceeded',
	'part_time_limit_exceeded',
}

export default DeviationEnum;

export const getDeviationClass = (value?: DeviationEnum | null): 'error' | 'warning' | 'acceptable_error' | null => {
	if (value === null || value === undefined) return null;
	if (
		[
			DeviationEnum.full_time_limit_exceeded,
			DeviationEnum.overworked_hours,
			DeviationEnum.part_time_limit_exceeded,
			DeviationEnum.underworked_hours,
		].includes(value)
	) {
		return 'warning';
	} else if ([DeviationEnum.scheduled_leave].includes(value)) {
		return 'error';
	} else if ([DeviationEnum.scheduled_leave_by_sick_or_paidleave].includes(value)) {
		return 'acceptable_error';
	}
	return null;
};
